import React, { useState, useContext } from "react";
import { Button, TextField, Typography, CircularProgress } from "@mui/material";
import DrawerContext from "../../context/DrawerContext";

import { createTag, createTopic, slugify, updateTag, updateTopic } from "../blogApi";

/*
 * Add/edit for tags and topics, which were four near-identical drawers against
 * deliva-api. blog-api's create takes a slug alongside the name; renaming does
 * NOT change the slug, because the slug is the public URL the site links to.
 */
const KINDS = {
  "create-tag": { className: "tags-drawer", heading: "Add Tag", label: "Tag Name", mode: "create", create: createTag },
  "edit-tag": { className: "tags-drawer", heading: "Edit Tag", label: "Tag Name", mode: "edit", update: updateTag },
  "add-topic": { className: "topics-drawer", heading: "Add Topic", label: "Topic Name", mode: "create", create: createTopic },
  "edit-topic": { className: "topics-drawer", heading: "Edit Topic", label: "Topic Name", mode: "edit", update: updateTopic },
};

const TermDrawer = ({ type }) => {
  const drawerCtx = useContext(DrawerContext);
  const isOpen = drawerCtx.details?.type === type;
  const config = KINDS[type];

  const [name, setName] = useState(drawerCtx.details?.name || "");
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);

  if (!isOpen) return null;

  const isSaveDisabled = name.trim() === "" || isSaving;

  const handleSave = async () => {
    if (isSaveDisabled) return;
    setIsSaving(true);
    setError(null);

    const trimmed = name.trim();

    try {
      if (config.mode === "create") {
        if (!slugify(trimmed)) {
          setError("That name has no letters or numbers to build a URL from.");
          setIsSaving(false);
          return;
        }
        await config.create({ slug: slugify(trimmed), name: trimmed });
      } else {
        if (!drawerCtx.details?.slug) {
          setError("This item has no slug, so it cannot be updated.");
          setIsSaving(false);
          return;
        }
        await config.update(drawerCtx.details.slug, { name: trimmed });
      }
      drawerCtx.setPageUpdate({ page: type.includes("tag") ? "Tags" : "Topics" });
      drawerCtx.closeDrawer();
    } catch (err) {
      console.error(err);
      setError(err.message);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className={`${config.className} open`}>
      <div className="drawer-header">
        <Typography variant="h6">{config.heading}</Typography>
      </div>
      <div className="drawer-content">
        <TextField
          className="full-width-column"
          fullWidth
          label={config.label}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        {error ? <p style={{ color: "#d32f2f", fontSize: "0.85rem" }}>{error}</p> : null}
      </div>
      <div className="manage-buttons">
        <Button variant="contained" className="cancel-button" onClick={drawerCtx.closeDrawer}>
          Cancel
        </Button>
        <Button variant="contained" className="btn-primary save-button" onClick={handleSave} disabled={isSaveDisabled}>
          {isSaving ? <CircularProgress size={24} style={{ color: "#fff" }} /> : "Save"}
        </Button>
      </div>
    </div>
  );
};

export default TermDrawer;
